/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, embedOverrides, mediaQuery } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EMBED CONTENT SELECTOR : STYLES --------------- ++++++++++ */
export default theme => ({
	contentselector: {
		background: theme.color.supporting.light.swatch,
		boxShadow: `0 -1px 0 0 rgba(6, 43, 117, 0.1)`,
		marginTop: pxToEm(30),
		padding: replacePXinStringWithEM(`15px 5% 15px 15px`),
		position: 'relative',
		transition: 'all .2s linear 0s',
		'&:hover': {
			background: '#f4f6f9'
		},
		'& .copy': {
			display: 'flex',
			flexWrap: 'wrap',
			justifyContent: 'space-between',
			marginBottom: pxToEm(10),
			'& .title': {
				flex: '1',
				display: 'flex',
				flexWrap: 'wrap',
				alignItems: 'baseline',
				textAlign: 'left',
				'& h5': {
					color: theme.color.primary.medium.swatch,
					extend: theme.typography.size.small,
					marginRight: pxToEm(10)
				},
				'& p': {
					color: theme.color.supporting.dark.swatch,
					extend: theme.typography.size.xxsmall
				}
			},
			'& .ctas': {
				paddding: replacePXinStringWithEM(`10px 10px 0 0`)
			}
		},
		'& .pagination':{
			marginTop: pxToEm(10)
		},
		'& .stepnav': {
			marginTop: pxToEm(50)
		},
		'& .cardcontainer': {
			display:'flex',
			overflow: 'auto',
			overflowY: 'hidden',
			whiteSpace: 'nowrap',
			width: '100%',
			textAlign: 'left',
            '&.greyOut':{
				display: 'none'
			},
			'& .contentcard': {
				marginRight: pxToEm(14),
				'&.active': {
					'& .contentvisual': {
						
					}
				},
				'& .delete': {
					fontSize: '80%'
				},
				// adjust embed to fit the size space
				extend: embedOverrides(40)
			}
		},

		// ..... RAIL ..... //
		'&.rail': {
			
		},

		// ..... IN CONTENT ..... //
		'&.incontent': {
			'& .contentcard': {
				'& .contentvisual': {
					height: pxToEm(106),
					width: pxToEm(180)
				}
			}
		}
	},

	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
	[mediaQuery.customizeThinnest]: { 
		contentselector: {
			padding: replacePXinStringWithEM(`15px`),
		}
	}
});
